import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '@Components/Button';
import { zoomSliderLevels } from '../ZoomConstants';

import ZoomSliderBar from './ZoomSliderBar';

import './ZoomSlider.scss';
import './InputRange.scss';

function ZoomSlider(props) {
  const { setZoomValue, zoomKey, zoomValue, min, max, step, className } = props;

  const minus = () => {
    if (zoomValue === min) {
      return;
    }

    const nextValue = zoomValue - step;

    if (nextValue < min) {
      setZoomValue(zoomKey, min);
    }

    setZoomValue(zoomKey, nextValue);
  };

  const plus = () => {
    if (zoomValue === max) {
      return;
    }

    const nextValue = zoomValue + step;

    if (nextValue > max) {
      setZoomValue(zoomKey, max);
    }

    setZoomValue(zoomKey, nextValue);
  };

  return (
    <div className={classnames('zoom-slider', className)}>
      <Button
        onClick={minus}
        buttonConfig={{
          type: 'link',
          size: 'small',
          e2eName: 'zoom-out',
          ariaLabel: 'Zoom out',
        }}
        iconConfig={{ name: 'zoom-out', size: 'small' }}
      />
      <ZoomSliderBar {...props} plus={plus} minus={minus} />
      <Button
        onClick={plus}
        buttonConfig={{
          type: 'link',
          size: 'small',
          e2eName: 'zoom-in',
          ariaLabel: 'Zoom in',
        }}
        iconConfig={{ name: 'zoom', size: 'small' }}
      />
    </div>
  );
}

ZoomSlider.defaultProps = {
  min: zoomSliderLevels.min,
  max: zoomSliderLevels.max,
  step: zoomSliderLevels.step,
};

ZoomSlider.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  setZoomValue: PropTypes.func,
  zoomKey: PropTypes.string,
  zoomValue: PropTypes.number,
  className: PropTypes.string,
};

export default ZoomSlider;
